<template>
  <div id="login">
    <transition name="fade">
      <div v-if="performingRequest" class="loading">
        <p>Loading...</p>
      </div>
    </transition>
    <button @click="googin" class="button">Log In With Googlerj</button>
  </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
  data () {
    return {
      performingRequest: false
    }
  },
  methods: {
    googin () {
      this.performingRequest = true
      var provider = new fb.firebase.auth.GoogleAuthProvider()
      fb.auth.signInWithRedirect(provider)
    }
  }
}
</script>
